<template>
    <b-overlay :show="isLoading" rounded="sm">
        <div v-if="isLoading" class="my-5" />
        <div v-else-if="!items.length && !isLoading" class="text-center my-5">
            <b-icon icon="exclamation-circle-fill" variant="danger" font-scale="2" />
            <p class="mt-2">No items found</p>
        </div>
        <div v-else class="list-group">
            <modal-import-list-item
                v-for="(item, index) in items"
                :key="index + '-item'"
                :item="item"
                @item-selected="itemSelected"
            />
        </div>
        <!-- <template #overlay>
      <div v-if="isLoading" class="text-center">
        <img width="80" height="80" :src="require('@/assets/images/loader.gif')" />
      </div>
    </template> -->
    </b-overlay>
</template>

<script lang="ts" setup>
import { Item } from '../../types';
import ModalImportListItem from './ModalImportListItem.vue';

withDefaults(
    defineProps<{
        isLoading: boolean;
        items?: Item[];
    }>(),
    { items: () => [] }
);

const emit = defineEmits<{
    (event: 'item-selected', value: Item): void;
}>();

const itemSelected = (item: Item) => {
    emit('item-selected', item);
};
</script>
